import React from 'react';

var Item = function Item(_ref) {
  var item = _ref.item,
      getItemsLabel = _ref.getItemsLabel;
  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null, getItemsLabel(item))
  );
};

export { Item };